import { PERSON_DEMOGRAPHICS } from '../../surveys/miway-4.js'
import SurveyShell from './SurveyShell.jsx'

const ORG_REQUIRED = 'Bitte geben Sie den Namen der Organisation an, in der Sie aktuell arbeiten.'

export default function DemographicsStep({
  step, total, data, onChange, onBack, onNext, validation, setValidation, logoSrc, logoNode,
}) {
  const d = data
  const requireAndAdvance = () => {
    if (!d.organisation?.trim()) { setValidation(ORG_REQUIRED); return }
    setValidation(null); onNext()
  }
  return (
    <SurveyShell
      step={step} total={total}
      title="Angaben zur Person"
      intro="Vervollständigen Sie bitte die Angaben zu Ihrer Person…"
      onBack={onBack}
      onNext={requireAndAdvance}
      validation={validation}
      logoSrc={logoSrc}
      logoNode={logoNode}
    >
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Alter">
          <input className="input" value={d.alter || ''} onChange={e => onChange({ alter: e.target.value })} />
        </Field>
        <Field label={<>Derzeitige Organisation <span className="text-rose-500">*</span></>}>
          <input className={`input ${validation ? 'input-error' : ''}`} value={d.organisation || ''} onChange={e => onChange({ organisation: e.target.value })} />
        </Field>
        <Field label="Derzeitige Position">
          <input className="input" value={d.position || ''} onChange={e => onChange({ position: e.target.value })} />
        </Field>
        <Field label="Derzeitiger Bereich der Organisation">
          <select className="input" value={d.bereich || ''} onChange={e => onChange({ bereich: e.target.value })}>
            <option value="">Bitte auswählen…</option>
            {PERSON_DEMOGRAPHICS.bereich.map(o => <option key={o}>{o}</option>)}
          </select>
        </Field>
        <Field label="Derzeitige Branche">
          <select className="input" value={d.branche || ''} onChange={e => onChange({ branche: e.target.value })}>
            <option value="">Bitte auswählen…</option>
            {PERSON_DEMOGRAPHICS.branche.map(o => <option key={o}>{o}</option>)}
          </select>
        </Field>
        <Field label="Führungsverantwortung">
          <select className="input" value={d.fuehrungsverantwortung || ''} onChange={e => onChange({ fuehrungsverantwortung: e.target.value })}>
            <option value="">Bitte auswählen…</option>
            {PERSON_DEMOGRAPHICS.fuehrung.map(o => <option key={o}>{o}</option>)}
          </select>
        </Field>
        <Field label="Höchster Bildungsabschluss">
          <select className="input" value={d.bildungsabschluss || ''} onChange={e => onChange({ bildungsabschluss: e.target.value })}>
            <option value="">Bitte auswählen…</option>
            {PERSON_DEMOGRAPHICS.bildung.map(o => <option key={o}>{o}</option>)}
          </select>
        </Field>
        <Field label="Fachrichtung">
          <input className="input" placeholder="(z.B. Bauingenieurwesen, Soziologie)" value={d.fachrichtung || ''} onChange={e => onChange({ fachrichtung: e.target.value })} />
        </Field>
      </div>
    </SurveyShell>
  )
}

function Field({ label, children }) {
  return <div><label className="label">{label}</label>{children}</div>
}
